export const emptyVitals = () => ({
  BLOOD_PRESSURE: '',
  PULSE: '',
  TEMPERATURE: '',
  WEIGHT: '',
  HEIGHT: '',
  SPO2: '',
  RESPIRATORY_RATE: ''
});

const RANGES = {
  PULSE: ['Pulse', 30, 220],
  TEMPERATURE: ['Temperature', 90, 110],
  WEIGHT: ['Weight', 1, 300],
  HEIGHT: ['Height', 30, 250],
  SPO2: ['SpO2', 50, 100],
  RESPIRATORY_RATE: ['Respiratory rate', 5, 60]
};

export function sanitizeVitals(input) {
  const source = input || {};
  const vitals = {};
  const pressure = String(source.BLOOD_PRESSURE || '').trim();
  if (pressure) {
    if (!/^\d{2,3}\/\d{2,3}$/.test(pressure)) {
      throw new Error('Blood pressure should look like 120/80.');
    }
    vitals.BLOOD_PRESSURE = pressure;
  }
  Object.entries(RANGES).forEach(([key, [label, min, max]]) => {
    if (source[key] === '' || source[key] == null) return;
    const value = Number(source[key]);
    if (!Number.isFinite(value) || value < min || value > max) {
      throw new Error(`${label} must be between ${min} and ${max}.`);
    }
    vitals[key] = value;
  });
  return vitals;
}

export function vitalLines(vitals) {
  if (!vitals) return [];
  const lines = [];
  if (vitals.BLOOD_PRESSURE) lines.push(`Blood pressure: ${vitals.BLOOD_PRESSURE} mmHg`);
  if (vitals.PULSE != null && vitals.PULSE !== '') lines.push(`Pulse: ${vitals.PULSE} bpm`);
  if (vitals.TEMPERATURE != null && vitals.TEMPERATURE !== '') lines.push(`Temperature: ${vitals.TEMPERATURE} °F`);
  if (vitals.WEIGHT != null && vitals.WEIGHT !== '') lines.push(`Weight: ${vitals.WEIGHT} kg`);
  if (vitals.HEIGHT != null && vitals.HEIGHT !== '') lines.push(`Height: ${vitals.HEIGHT} cm`);
  if (vitals.SPO2 != null && vitals.SPO2 !== '') lines.push(`SpO2: ${vitals.SPO2}%`);
  if (vitals.RESPIRATORY_RATE != null && vitals.RESPIRATORY_RATE !== '') lines.push(`Respiratory rate: ${vitals.RESPIRATORY_RATE}/min`);
  const weight = Number(vitals.WEIGHT);
  const height = Number(vitals.HEIGHT);
  if (weight > 0 && height > 0) {
    const meters = height / 100;
    lines.push(`BMI: ${(weight / (meters * meters)).toFixed(1)}`);
  }
  return lines;
}

export function writeVitals(doc, x, y, vitals, width = 170) {
  const lines = vitalLines(vitals);
  if (!lines.length) return y;
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.text('VITALS', x, y);
  y += 10;
  doc.setFontSize(12);
  doc.setFont('helvetica', 'normal');
  lines.forEach((line) => {
    const wrapped = doc.splitTextToSize(line, width);
    doc.text(wrapped, x, y);
    y += wrapped.length * 6;
  });
  return y + 6;
}
